
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2448',
  depVersions: {
  "customer-portal-app": "static-1.2448",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.473",
  "data-fetching-client": "static-1.9710",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25513",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5635",
  "hs-test-utils": "static-1.8060",
  "hub-http": "static-1.6267",
  "hub-http-shared-msw-handlers": "static-1.10073",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18360",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11518",
  "I18n": "static-7.1633",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6508",
  "payment-link-components": "static-1.23634",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7086",
  "quartz-core": "static-1.6305",
  "quartz-i18n": "static-1.761",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10253",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5379",
  "rich-text-lib": "static-1.19909",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18060",
  "ui-components-test-utils": "static-1.5655",
  "UIComponents": "static-3.8464",
  "foundations-assets": "static-1.4914",
  "foundations-components": "static-1.8019",
  "foundations-theming": "static-1.4463",
  "foundations-theming-specialty": "static-1.2179",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.990",
  "quartz-config": "static-1.864",
  "quartz-routing": "static-1.516",
  "quick-fetch": "static-1.3952",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "rpc-client-utils": "static-1.4697",
  "sanitize-text": "static-1.8187",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4807",
  "ui-addon-react-router-dom": "static-1.9586",
  "usage-tracker": "static-1.7394",
  "usage-tracker-anonymous": "static-1.5811",
  "usage-tracker-core": "static-1.7244",
  "video-components-external": "static-1.11441",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3434",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3363",
  "quartz-webpack": "static-1.3310",
  "bend-plugin-quartz-routing": "static-1.164",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7720",
  "frontend-preferences-client": "static-1.7971",
  "laboratory-lib": "static-3.7200",
  "onboarding-scopes": "static-1.6506",
  "seat-types-lib": "static-1.123",
  "ui-addon-opt": "static-4.8407",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3171",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.116",
  "ts-schema": "static-1.4115",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7820",
  "cssUtils": "static-1.801",
  "customer-data-ui-utilities": "static-1.9870",
  "HubStyle": "static-2.11825",
  "knowledge-content-types": "static-1.8509",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.488",
  "ui-addon-emoji-picker": "static-1.9931",
  "ui-addon-i18n": "static-1.11196",
  "ui-business-units-lib": "static-1.9102",
  "ui-shepherd-react": "static-3.10245",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4370",
  "commerce-tours-lib": "static-1.6186",
  "customer-data-properties": "static-1.51724",
  "getting-started-shared-tasks": "static-1.18559",
  "growth-onboarding-reliability": "static-1.5125",
  "onboarding-tours": "static-1.16688",
  "reference-resolvers-lite": "static-1.8140",
  "sales-checkout-service-client": "static-1.3686",
  "ui-addon-iframeable": "static-1.9104",
  "user-context": "static-1.5151",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4686",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.761",
  "quartz-head": "static-1.751",
  "quartz-test": "static-1.761",
  "quartz-tracking": "static-1.465",
  "ui-fonts": "static-1.780",
  "usage-tracker-container": "static-1.7384",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9468",
  "data-token-picker": "static-1.16484",
  "FileManagerLib": "static-1.39383",
  "property-translator": "static-1.5443",
  "atom": "static-1.5119",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.5995",
  "salesImages": "static-1.526",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5502",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1163",
  "bend-plugin-foundations-components": "static-1.4288",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.31",
  "trellis-assets": "static-1.2056",
  "bend-plugin-foundations-theming": "static-1.2946",
  "foundations-theming-base": "static-1.3448",
  "stylex": "static-1.33",
  "interframe": "static-3.4803",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5808",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.107",
  "chirp-fetch": "static-1.1932",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4520",
  "react-flip-move": "static-1.71",
  "apollo-link-hub-http": "static-2.4696",
  "content-media-composition-data-lib": "static-1.12497",
  "content-media-compositions": "static-2.16504",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4198",
  "magpie-lib": "static-1.5580",
  "magpie-types": "static-1.5040",
  "media-bridge-lib": "static-1.19004",
  "video-data-lib": "static-1.35099",
  "bender-build-tools": "static-1.3227",
  "inbound-db-properties-service-client": "static-1.3881",
  "superstore": "static-1.4804",
  "feedback-loader": "static-1.29379",
  "ai-components-ui-library": "static-1.9085",
  "ui-addon-video-player": "static-1.8748",
  "ui-coaching-tips": "static-1.28690",
  "sassPrefix": "static-1.157",
  "react-dnd-compat": "static-1.4658",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2542",
  "navigation-messaging": "static-1.7481",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8216",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9732",
  "crm-message-bus": "static-1.43092",
  "growth-data-modal": "static-1.5497",
  "hubspot-apollo-client": "static-1.4922",
  "onboarding-tours-client": "static-1.4902",
  "calling-global-api": "static-1.64669",
  "calling-internal-common": "static-1.31348",
  "calling-lifecycle-internal": "static-1.66051",
  "calling-lifecycle-messages": "static-1.58345",
  "conditional-properties-service-client": "static-1.3833",
  "crm-links": "static-1.6348",
  "crm-pipelines-api-client-types": "static-1.4175",
  "customer-data-objects-ui-components": "static-1.13075",
  "customer-data-properties-shared-msw-handlers": "static-1.9400",
  "customer-data-property-utils": "static-1.8135",
  "external-options-client-types": "static-1.4194",
  "file-manager-components": "static-1.23743",
  "framework-data-schema-resolvers": "static-1.6931",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.206",
  "inbound-db-meta-service-client": "static-1.3621",
  "inbounddb-objects-service-types": "static-1.4258",
  "meetings-icalendar-utils-lib": "static-1.676",
  "multi-currency-client-types": "static-1.3727",
  "object-builder-ui-client": "static-1.48901",
  "pipeline-validation-client-types": "static-1.4001",
  "property-value-citations": "static-1.2338",
  "pulse": "static-1.626",
  "smart-property-lib": "static-1.7332",
  "tiered-pricing": "static-1.1318",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11034",
  "growth-onboarding-confetti": "static-1.3111",
  "growth-onboarding-next-action-utils": "static-1.2054",
  "navigation-components": "static-1.18154",
  "onboarding-tours-utils": "static-1.754",
  "ui-shepherd-tracker": "static-1.7626",
  "ui-universal-auth": "static-1.9031",
  "batch-promise": "static-1.1586",
  "getting-started-shared-tasks-store": "static-1.17677",
  "hubspotter-http-shared-msw-handlers": "static-1.10071",
  "usage-tracker-session-replay": "static-1.5080",
  "audio-components": "static-1.5982",
  "FileManagerCore": "static-1.39242",
  "FileManagerImages": "static-1.36894",
  "video-components": "static-1.13443",
  "foundations-components-legacy": "static-1.1044",
  "purchase-motions-api": "static-1.5998",
  "signup-constants": "static-1.18930",
  "signup-ui-url-generator": "static-2.8098",
  "usage-tracker-public": "static-1.7205",
  "reactive-lib": "static-1.768",
  "simple-logging-lib": "static-1.3095",
  "chatspot-core": "static-1.21484",
  "ContentUtils": "static-1.68501",
  "copilot-toolkit": "static-1.11254",
  "growth-onboarding-feedback-components": "static-1.6624",
  "commerce-permissions": "static-1.818",
  "customer-data-tracking": "static-1.6934",
  "products-iframe-lib": "static-1.8064",
  "products-ui-components-shared-msw-handlers": "static-1.10455",
  "restore-request-side-panel-lib": "static-1.1029",
  "onboarding-data-sync-lib": "static-1.2027",
  "hubspot-apollo-cache": "static-1.381",
  "calling-error-reporting": "static-1.31355",
  "shared-worker-versioning": "static-1.11080",
  "calling-usage-tracker": "static-1.6585",
  "self-service-api": "static-1.10291",
  "voice-sms-access-library": "static-1.1189",
  "conversations-skeleton-state": "static-1.7293",
  "location-customization-utils-lib": "static-1.9396",
  "fdsr-migration-layer": "static-1.50",
  "framework-builder-read-service-client": "static-1.4040",
  "framework-data-schema-quick-fetch": "static-1.6836",
  "persist-promise": "static-1.3743",
  "bend-plugin-pulse": "static-1.129",
  "event-emitter": "static-1.992",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.264",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10156",
  "fsm": "static-1.3775",
  "policy-lib": "static-1.6821",
  "react-tinymce": "static-1.55374",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10219",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54500",
  "tinymce-plugins": "static-1.57614",
  "tinymce-themes": "static-1.56470",
  "growth-onboarding-next-action-components": "static-1.2082",
  "user-context-client": "static-1.4655",
  "nest": "static-1.276",
  "unified-auth-core-lib": "static-1.827",
  "amplitude-session-replay-browser": "static-1.62",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4582",
  "video-embed": "static-1.35933",
  "content-icons-ui": "static-1.2236",
  "social-insights-client-types": "static-1.22229",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4856",
  "integrations-lib": "static-1.16312",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.808",
  "sales-views-client-types": "static-1.4301",
  "InboxConnectUtils": "static-4.14941",
  "meetings-connect-utils-lib": "static-1.7649",
  "calling-orchestration-schema": "static-1.35966",
  "crm-record-cards-service-types": "static-1.3625",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4558",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3086",
  "tinymce-data": "static-1.40585",
  "ui-addon-sales-email": "static-1.5255",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12528",
  "layout-dnd-utils": "static-1.11503",
  "react-codemirror": "static-1.10672",
  "ui-brand-identity-lib": "static-1.15461",
  "NamespacedHubStyle": "static-2.9094",
  "outpost": "static-1.4221",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13727",
  "integrations-tracking-lib": "static-1.5647",
  "native-integrations-shared-strings": "static-1.7826",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10409",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.545",
  "breeze-engine-core": "static-1.86",
  "ably": "static-2.2",
  "highlight.js": "static-1.79",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68576",
  "layout-data-lib": "static-1.9828",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3060",
  "google-sheets-integration-lib": "static-1.373",
  "microsoft-drive-integration-lib": "static-1.501",
  "slack-ui-library": "static-1.10436",
  "advanced-menus-core": "static-1.15197",
  "advanced-menus-lib": "static-1.12134",
  "ExportDialog": "static-6.10430",
  "ui-memberships-settings-lib": "static-1.34173",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15196",
  "simple-menus-lib": "static-1.16713"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2448",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.473",
  "data-fetching-client": "/data-fetching-client/static-1.9710",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25513",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5635",
  "hs-test-utils": "/hs-test-utils/static-1.8060",
  "hub-http": "/hub-http/static-1.6267",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10073",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18360",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11518",
  "I18n": "/I18n/static-7.1633",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6508",
  "payment-link-components": "/payment-link-components/static-1.23634",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7086",
  "quartz-core": "/quartz-core/static-1.6305",
  "quartz-i18n": "/quartz-i18n/static-1.761",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10253",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5379",
  "rich-text-lib": "/rich-text-lib/static-1.19909",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18060",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5655",
  "UIComponents": "/UIComponents/static-3.8464",
  "foundations-assets": "/foundations-assets/static-1.4914",
  "foundations-components": "/foundations-components/static-1.8019",
  "foundations-theming": "/foundations-theming/static-1.4463",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2179",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.990",
  "quartz-config": "/quartz-config/static-1.864",
  "quartz-routing": "/quartz-routing/static-1.516",
  "quick-fetch": "/quick-fetch/static-1.3952",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "rpc-client-utils": "/rpc-client-utils/static-1.4697",
  "sanitize-text": "/sanitize-text/static-1.8187",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4807",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9586",
  "usage-tracker": "/usage-tracker/static-1.7394",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5811",
  "usage-tracker-core": "/usage-tracker-core/static-1.7244",
  "video-components-external": "/video-components-external/static-1.11441",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3434",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3363",
  "quartz-webpack": "/quartz-webpack/static-1.3310",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.164",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7720",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7971",
  "laboratory-lib": "/laboratory-lib/static-3.7200",
  "onboarding-scopes": "/onboarding-scopes/static-1.6506",
  "seat-types-lib": "/seat-types-lib/static-1.123",
  "ui-addon-opt": "/ui-addon-opt/static-4.8407",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3171",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.116",
  "ts-schema": "/ts-schema/static-1.4115",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7820",
  "cssUtils": "/cssUtils/static-1.801",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9870",
  "HubStyle": "/HubStyle/static-2.11825",
  "knowledge-content-types": "/knowledge-content-types/static-1.8509",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9931",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11196",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9102",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10245",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4370",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6186",
  "customer-data-properties": "/customer-data-properties/static-1.51724",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18559",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5125",
  "onboarding-tours": "/onboarding-tours/static-1.16688",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8140",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3686",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9104",
  "user-context": "/user-context/static-1.5151",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4686",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.761",
  "quartz-head": "/quartz-head/static-1.751",
  "quartz-test": "/quartz-test/static-1.761",
  "quartz-tracking": "/quartz-tracking/static-1.465",
  "ui-fonts": "/ui-fonts/static-1.780",
  "usage-tracker-container": "/usage-tracker-container/static-1.7384",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9468",
  "data-token-picker": "/data-token-picker/static-1.16484",
  "FileManagerLib": "/FileManagerLib/static-1.39383",
  "property-translator": "/property-translator/static-1.5443",
  "atom": "/atom/static-1.5119",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.5995",
  "salesImages": "/salesImages/static-1.526",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5502",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1163",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4288",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "trellis-assets": "/trellis-assets/static-1.2056",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2946",
  "foundations-theming-base": "/foundations-theming-base/static-1.3448",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4803",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5808",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.107",
  "chirp-fetch": "/chirp-fetch/static-1.1932",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4520",
  "react-flip-move": "/react-flip-move/static-1.71",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4696",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12497",
  "content-media-compositions": "/content-media-compositions/static-2.16504",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4198",
  "magpie-lib": "/magpie-lib/static-1.5580",
  "magpie-types": "/magpie-types/static-1.5040",
  "media-bridge-lib": "/media-bridge-lib/static-1.19004",
  "video-data-lib": "/video-data-lib/static-1.35099",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3881",
  "superstore": "/superstore/static-1.4804",
  "feedback-loader": "/feedback-loader/static-1.29379",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9085",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8748",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28690",
  "sassPrefix": "/sassPrefix/static-1.157",
  "react-dnd-compat": "/react-dnd-compat/static-1.4658",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2542",
  "navigation-messaging": "/navigation-messaging/static-1.7481",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8216",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9732",
  "crm-message-bus": "/crm-message-bus/static-1.43092",
  "growth-data-modal": "/growth-data-modal/static-1.5497",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4922",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4902",
  "calling-global-api": "/calling-global-api/static-1.64669",
  "calling-internal-common": "/calling-internal-common/static-1.31348",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66051",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58345",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3833",
  "crm-links": "/crm-links/static-1.6348",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4175",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13075",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9400",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8135",
  "external-options-client-types": "/external-options-client-types/static-1.4194",
  "file-manager-components": "/file-manager-components/static-1.23743",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6931",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.206",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3621",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4258",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.676",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3727",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48901",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4001",
  "property-value-citations": "/property-value-citations/static-1.2338",
  "pulse": "/pulse/static-1.626",
  "smart-property-lib": "/smart-property-lib/static-1.7332",
  "tiered-pricing": "/tiered-pricing/static-1.1318",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11034",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3111",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2054",
  "navigation-components": "/navigation-components/static-1.18154",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.754",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7626",
  "ui-universal-auth": "/ui-universal-auth/static-1.9031",
  "batch-promise": "/batch-promise/static-1.1586",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17677",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10071",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5080",
  "audio-components": "/audio-components/static-1.5982",
  "FileManagerCore": "/FileManagerCore/static-1.39242",
  "FileManagerImages": "/FileManagerImages/static-1.36894",
  "video-components": "/video-components/static-1.13443",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1044",
  "purchase-motions-api": "/purchase-motions-api/static-1.5998",
  "signup-constants": "/signup-constants/static-1.18930",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8098",
  "usage-tracker-public": "/usage-tracker-public/static-1.7205",
  "reactive-lib": "/reactive-lib/static-1.768",
  "simple-logging-lib": "/simple-logging-lib/static-1.3095",
  "chatspot-core": "/chatspot-core/static-1.21484",
  "ContentUtils": "/ContentUtils/static-1.68501",
  "copilot-toolkit": "/copilot-toolkit/static-1.11254",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6624",
  "commerce-permissions": "/commerce-permissions/static-1.818",
  "customer-data-tracking": "/customer-data-tracking/static-1.6934",
  "products-iframe-lib": "/products-iframe-lib/static-1.8064",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10455",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1029",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2027",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.381",
  "calling-error-reporting": "/calling-error-reporting/static-1.31355",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11080",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6585",
  "self-service-api": "/self-service-api/static-1.10291",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1189",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7293",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9396",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.50",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4040",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6836",
  "persist-promise": "/persist-promise/static-1.3743",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.129",
  "event-emitter": "/event-emitter/static-1.992",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.264",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10156",
  "fsm": "/fsm/static-1.3775",
  "policy-lib": "/policy-lib/static-1.6821",
  "react-tinymce": "/react-tinymce/static-1.55374",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10219",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54500",
  "tinymce-plugins": "/tinymce-plugins/static-1.57614",
  "tinymce-themes": "/tinymce-themes/static-1.56470",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2082",
  "user-context-client": "/user-context-client/static-1.4655",
  "nest": "/nest/static-1.276",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.827",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.62",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4582",
  "video-embed": "/video-embed/static-1.35933",
  "content-icons-ui": "/content-icons-ui/static-1.2236",
  "social-insights-client-types": "/social-insights-client-types/static-1.22229",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4856",
  "integrations-lib": "/integrations-lib/static-1.16312",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.808",
  "sales-views-client-types": "/sales-views-client-types/static-1.4301",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14941",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7649",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35966",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3625",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4558",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3086",
  "tinymce-data": "/tinymce-data/static-1.40585",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5255",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12528",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11503",
  "react-codemirror": "/react-codemirror/static-1.10672",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15461",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9094",
  "outpost": "/outpost/static-1.4221",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13727",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5647",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7826",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10409",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.545",
  "breeze-engine-core": "/breeze-engine-core/static-1.86",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.79",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68576",
  "layout-data-lib": "/layout-data-lib/static-1.9828",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3060",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.373",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.501",
  "slack-ui-library": "/slack-ui-library/static-1.10436",
  "advanced-menus-core": "/advanced-menus-core/static-1.15197",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12134",
  "ExportDialog": "/ExportDialog/static-6.10430",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34173",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15196",
  "simple-menus-lib": "/simple-menus-lib/static-1.16713"
}
};
